import { ServiceData } from '../service';
import db from '../index';
import { entityServiceFactory } from '../entityServiceFactory';

export interface UsersServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<UsersServiceData>(db, 'usersService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
